import { render, staticRenderFns } from "./collageGoodsType.vue?vue&type=template&id=45edd2c6&scoped=true&"
import script from "./collageGoodsType.vue?vue&type=script&lang=js&"
export * from "./collageGoodsType.vue?vue&type=script&lang=js&"
import style0 from "./collageGoodsType.vue?vue&type=style&index=0&id=45edd2c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45edd2c6",
  null
  
)

export default component.exports